import './button.scss';

import { Spin } from 'antd';
import { forwardRef } from 'react';

import { LoadingOutlined } from '@/media/antd-icons';

interface IProps extends Omit<React.HTMLProps<HTMLButtonElement>, 'size'> {
  children: string | React.ReactNode;
  size?: 'small' | 'big' | 'wizard';
  variant?:
    | 'filled-red'
    | 'filled-green'
    | 'filled-black'
    | 'filled-purple'
    | 'outlined'
    | 'outlined-surface'
    | 'filled-blue'
    | 'outlined-red';
  type?: 'button' | 'submit' | 'reset';
  isLoading?: boolean;
  fullWidth?: boolean;
  isReversed?: boolean;
  isSquare?: boolean;
}

const Button = forwardRef<HTMLButtonElement, IProps>(
  (
    {
      children,
      isLoading,
      size,
      variant = 'outlined',
      fullWidth,
      isReversed,
      isSquare,
      ...props
    },
    ref
  ) => {
    const buttonClass = [
      'button',
      props.className ? ` ${props.className}` : '',
      size ? ` button--${size}` : '',
      variant ? ` button--${variant}` : '',
      fullWidth ? ` button--full-width` : '',
      isReversed ? ' button--reversed' : '',
      isSquare ? ' button--square' : ''
    ].join('');

    return (
      <button
        {...props}
        type={props.type}
        ref={ref}
        id={props.id}
        className={buttonClass}
        disabled={props.disabled || isLoading}
        onClick={props.onClick}
      >
        {children}
        {isLoading && <Spin indicator={<LoadingOutlined />} size="small" />}
      </button>
    );
  }
);

Button.displayName = 'Button';

export default Button;
